<template>
	<div class="fanoffer-preferences-view">
		<div class="fanoffer-preferences-view__header">
			<h2 class="common__heading bottom-gap-lg">Fan Offers</h2>
    </div>
    <div class="offer-form-group__item">
      <offer :offer="{
        id: 28,
        img: 'images/offers/fan_offer_tile.png',
        isChecked: true,
        offtype: 'partner',
        description: 'Sign in or create a Football Account and you go in the draw to win your very own signed CommBank Matildas or Socceroos jersey.',
        title: 'WIN',
        isFanOffer: true,
      }" >

      </offer>
    </div>
    <div class="common__sub-heading top-gap-25">Terms and Conditions
      <a href = "https://www.footballaustralia.com.au/sites/ffa/files/2021-12/21-1214%20-%20Create%20a%20Football%20Account%20Competition_Terms%20and%20Conditions_.pdf" target="new" class="styled-form__link"> CLICK HERE </a>
    </div>
	</div>
</template>

<script>
	import Checkbox from '../formFields/Checkbox.vue';
  import Offer from "../formFields/Offer";

	export default {
		components: {
      Offer,
			Checkbox
		},
		props: {
      offer: Object,
		},
		data(){
      return {
        isLoading: false,
        checkbox: {
          isChecked: true,
          txt: 'Redeemed'
        }
			}
		},
    methods: {
      claimSignedShirt () {
        console.info("START_calling_user.OPTIN");
        console.time("TIME_calling_user.OPTIN");
        return this.$store.dispatch('onboarding/OPTIN', { optin: true }).then((fanOffers) => {
          console.timeEnd("TIME_calling_user.OPTIN");
          this.$emit('updateOffer', fanOffers.data.offers[0])

        });
      }
    }
	};
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";

	$columnsFlexBasis: (
		default : 100%,
		tablet: 33.3333%
	);

	$bottomPadding: (
		default: 30px
	);

	.fanoffer-preferences-view {

		position: relative;

		&__container {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-right: -15px;
			margin-bottom: -15px;
			padding-bottom: 25px;

			&:last-of-type {
				padding-bottom: 0;
			}
		}

		&__item {
			@include attr-bp($columnsFlexBasis, 'flex-basis');
			@include attr-bp($columnsFlexBasis, 'max-width'); // IE fix

			padding-right: 15px;
			margin-bottom: 25px;
			flex-grow: 0;
			flex-shrink: 0;

			&--full-width {
				flex-basis: 100%;
				max-width: 100%; // IE fix
			}
		}

		&::after {
			content: '';
			position: absolute;
			height: 0;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: $col-neutral--0;
			opacity: 0;
			transition: opacity $ttime;
		}

		@include mq(largeTablet) {
			&__header {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
			}
		}
	}

  .offer {
    $b: &;

    position: relative;
    width: 100%;

    &__inner {
      background-color: $col-neutral--0;
      border: 1px solid $col-neutral--3;
      transition: background-color $ttime;
      display: flex;
      min-height: 160px;
    }

    &__checkbox {
      display: block;
      position: absolute;
      top: 15px;
      right: 15px;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 1px solid $col-neutral--3;
      background-color: $col-neutral--0;
      overflow: hidden;
      transition: background-color, border-color;
      transition-duration: $ttime;

      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 9px;
        height: 3px;
        border-left: 3px solid $col-neutral--0;
        border-bottom: 3px solid $col-neutral--0;
        top: 45%;
        left: 110%;
        transform: translateX(-50%) translateY(-50%) rotate(-45deg);
        transition: left $ttime;
      }
    }
  }
</style>